// extracted by mini-css-extract-plugin
export default {"loginPage":"styles_loginPage__nI1yZ"};